import { render, staticRenderFns } from "./FinalizeTruckModal.vue?vue&type=template&id=546ae486"
import script from "./FinalizeTruckModal.vue?vue&type=script&lang=ts"
export * from "./FinalizeTruckModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports